import { useQuery } from '@tanstack/react-query';

import { useApi, useTenant } from '@/context';

// Tenant-scoped: the API only returns the workflows the tenant's subscription
// plan allows, so two organizations on different plans get different answers.
export const workflowKeys = {
    all: (tenantId: string) => ['workflows', tenantId] as const,
    list: (tenantId: string) => [...workflowKeys.all(tenantId), 'list'] as const,
    detail: (tenantId: string, id: string) => [...workflowKeys.all(tenantId), id] as const,
};

export function useWorkflows() {
    const api = useApi();
    const { tenantId } = useTenant();

    return useQuery({
        queryKey: workflowKeys.list(tenantId!),
        queryFn: () => api.workflows.list(),
        enabled: !!tenantId,
    });
}

export function useWorkflow(workflowId: string | undefined) {
    const api = useApi();
    const { tenantId } = useTenant();

    return useQuery({
        queryKey: workflowKeys.detail(tenantId!, workflowId!),
        queryFn: () => api.workflows.getById(workflowId!),
        enabled: !!workflowId && !!tenantId,
    });
}
